module.exports = __webpack_public_path__ + "static/media/swallow.6c0edf12.mp3";